import React, { useEffect, useState } from 'react';
import { Form, Modal, InputNumber, Space, message } from 'antd';
import emiter, { _EVENTS } from '../../../../events';
import { ExclamationCircleTwoTone } from '@ant-design/icons';
import { useCarModelPrice } from '../../../../hooks/product-price/car-model-price';

interface PropsType {
	enums?: any;
	detail?: any;
}

const EditPrice: React.FC<PropsType> = props => {
	const { detail } = props;
	const [form] = Form.useForm();

	const { tableActionEdit, update } = useCarModelPrice();

	const [showModal, setShowModal] = useState(false);
	const [selectedDates, setSelectedDates] = useState([]);

	const mainFormFields = {
		xiugaijiagewei: {
			name: 'price',
			label: '修改价格为',
			required: true,
			message: '请输入价格',
			placeholder: '请输入',
		},
	};

	const openModal = (selectedDates: any) => {
		setSelectedDates(selectedDates);
		setShowModal(true);
	};

	// 关闭弹窗
	const closeModal = () => {
		form.resetFields();
		setShowModal(false);
	};

	const validatePrice = (_: any, value: any) => {
		if (!value) {
			return Promise.reject(new Error('请输入价格'));
		}
		if (value > 5000 || value < 1) {
			return Promise.reject(new Error('请输入1-5000的正整数'));
		}
		return Promise.resolve();
	};

	const formatPrice = (price: any) => {
		if (!price) return price;
		if (!isNaN(Number(price))) {
			price = price * 100;
		}
		return price;
	};

	// 确认修改价格
	const confirmEditPrice = () => {
		form.validateFields().then(async (fieldsValue: any) => {
			const holiday: any[] = [];
			selectedDates.forEach((item: any) => {
				const every = {
					day: item,
					price: formatPrice(fieldsValue.price),
				};
				holiday.push(every);
			});
			const params = {
				...detail,
			};
			params.price_detail.holiday = holiday;
			const result: any = await update(params);
			if (result.errno === 0) {
				message.success('操作成功');
				closeModal();
				tableActionEdit(detail);
				// 清空选择日期
				emiter.emit(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.CLEAR_DATES);
			}
		});
	};

	useEffect(() => {
		emiter.on(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.EDIT_PRICE, openModal);
		return () => {
			emiter.removeAllListeners(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.EDIT_PRICE)
		}
	}, []);

	return (
		<Modal title="价格调整" open={showModal} onCancel={closeModal} centered onOk={confirmEditPrice}>
			<Form form={form}>
				<Form.Item
					required
					label={mainFormFields.xiugaijiagewei.label}
					name={mainFormFields.xiugaijiagewei.name}
					rules={[
						{
							validator: validatePrice,
						},
					]}
				>
					<InputNumber
						placeholder={mainFormFields.xiugaijiagewei.placeholder}
						controls={false}
						addonAfter={<div>元/天</div>}
						precision={0}
					/>
				</Form.Item>
			</Form>
			<Space align="baseline">
				<ExclamationCircleTwoTone twoToneColor="#f82f1e" />
				确认修改后，价格立即生效
			</Space>
		</Modal>
	);
};

export default EditPrice;
